<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <article>
        <h2>회원가입</h2>
        <ul class="breadCrumb">
          <li class="home"></li>
          <li>
            <p class="pageTxt">회원가입(일반)</p>
            <ul class="depth">
              <li><router-link to="/membershipagreement" title="회원가입(일반)">회원가입(일반)</router-link></li>
              <li><router-link to="/businessagreement" title="회원가입(사업자)">회원가입(사업자)</router-link></li>
            </ul>
          </li>
        </ul>
      </article>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <!--stepArea-->
        <div class="stepArea web">
          <ul>
            <li class="on">
              <span>1</span>
              <p>이용약관 확인 및 동의</p>
            </li>
            <li class="on">
              <span>2</span>
              <p>본인인증</p>
            </li>
            <li>
              <span>3</span>
              <p>정보입력</p>
            </li>
            <li class="on">
              <span>4</span>
              <p>회원가입 신청완료</p>
            </li>
          </ul>
        </div>
        <div class="stepArea mobile">
          <ul>
            <li class="on">
              <span>1</span>
              <p>이용약관 확인 및 동의</p>
            </li>
            <li class="on">
              <span>2</span>
              <p>본인인증</p>
            </li>
            <li>
              <span>3</span>
              <p>정보입력</p>
            </li>
            <li class="on">
              <span>4</span>
              <p>회원가입 신청완료</p>
            </li>
          </ul>
        </div>
        <!--//stepArea-->

        <!--table pc-->
        <div class="table horizontal-table web">
          <table>
            <caption>
              회원가입 정보입력 테이블
            </caption>
            <colgroup>
              <col style="width: 15%" />
              <col style="width: 35%" />
              <col style="width: 15%" />
              <col style="width: auto" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">아이디<span class="redDot">*</span></th>
                <td>
                  <div class="flex">
                    <input type="text" title="아이디 입력" v-model="empNo" @input="resetUsedCnt" />
                    <button type="button" class="btn gray" @click="idCheck">중복확인</button>
                  </div>
                  <div v-if="usedCnt === 1" class="reference orange">중복된 아이디입니다.</div>
                  <div v-if="usedCnt === 0" class="reference orange">사용 가능한 아이디입니다.</div>
                  <div v-if="usedCnt === -2" class="reference orange">
                    조건에 맞지 않습니다. ※5~20자의 영문 소문자, 숫자와 특수문자 -, _ 만 사용 가능합니다.
                  </div>
                  <div class="error" v-if="empNorequired">필수 입력란입니다.</div>
                  <div class="error" v-if="empNoidRegex">
                    조건에 맞지 않습니다. ※5~20자의 영문 소문자, 숫자와 특수문자 -, _ 만 사용 가능합니다.
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">비밀번호<span class="redDot">*</span></th>
                <td>
                  <input
                    type="password"
                    title="비밀번호 입력"
                    placeholder="영문,숫자,특수문자 조합 8-20자리"
                    v-model="password"
                  />
                  <div class="error" v-if="passwordrequired">필수 입력란입니다.</div>
                  <div class="error" v-if="passwordminLength">8~20자리 입력란입니다.</div>
                  <div class="error" v-if="passwordmaxLength">8~20자리 입력란입니다.</div>
                  <div class="error" v-if="passwordpassRegex">
                    조건에 맞지 않습니다.<br />※ 숫자,영문자,특수문자(!,@,#,$,%,&,*,? 만 사용 가능합니다.)
                  </div>
                </td>
                <th scope="row">비밀번호 확인<span class="redDot">*</span></th>
                <td>
                  <input type="password" title="비밀번호 재입력" v-model="passwordCon" />
                  <div class="error" v-if="passwordConrequired">필수 입력란입니다.</div>
                  <div class="error" v-if="passwordConsameAsPassword">일치하지 않는 비밀번호입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">이름<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="이름" v-model="empNm" />
                  <div class="error" v-if="empNmrequired">필수 입력란입니다.</div>
                </td>
                <th scope="row">휴대폰번호<span class="redDot">*</span></th>
                <td>
                  <div class="flex">
                    <input type="text" title="휴대폰번호" v-model="empMobile" />
                    <button type="button" class="btn gray" @click="sendAuthNum">중복확인</button>
                  </div>
                  <div class="error" v-if="empMobilerequired">필수 입력란입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">차량번호<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="차량번호 입력" v-model="empCarNo" />
                  <div class="error" v-if="empCarNorequired">필수 입력란입니다.</div>
                  <div class="error" v-if="empCarNocarNoCheck">형식에 맞지 않는 차량번호입니다.</div>
                </td>
                <th scope="row">차량소유주명<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="차량소유주명 입력" v-model="carOwnerNm" />
                  <div class="error" v-if="carOwnerNmrequired">필수 입력란입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">차종</th>
                <td>
                  <input type="text" title="차종 입력" />
                </td>
                <th scope="row">할인<span class="redDot">*</span></th>
                <td>
                  <div class="flex">
                    <input
                      v-for="(dc, index) in discountList"
                      :key="index"
                      type="text"
                      :value="dc.note"
                      title="할인 입력"
                    />
                    <button type="button" @click="chkIrs" class="btn gray">할인적용확인</button>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">주소</th>
                <td colspan="3">
                  <div class="address">
                    <div class="flex">
                      <input type="text" title="우편번호 입력" v-model="zipcode" readonly />
                      <button type="button" class="btn gray" @click="daumPostcodeBtn">우편번호</button>
                    </div>
                    <div class="flex">
                      <input type="text" title="주소 입력" v-model="addr" readonly />
                      <input type="text" title="상세주소 입력" v-model="addrDetail" />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--//table pc-->

        <!--table mobile-->
        <div class="table horizontal-table mobile">
          <table>
            <caption>
              회원가입 정보입력 테이블
            </caption>
            <colgroup>
              <col style="width: 35%" />
              <col style="width: 65%" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">아이디<span class="redDot">*</span></th>
                <td>
                  <div class="flex">
                    <input type="text" title="아이디 입력" v-model="empNo" @input="resetUsedCnt" />
                    <button type="button" class="btn gray" @click="idCheck">중복확인</button>
                  </div>
                  <div v-if="usedCnt === 1" class="reference orange">중복된 아이디입니다.</div>
                  <div v-if="usedCnt === 0" class="reference orange">사용 가능한 아이디입니다.</div>
                  <div v-if="usedCnt === -2" class="reference orange">
                    조건에 맞지 않습니다. ※5~20자의 영문 소문자, 숫자와 특수문자 -, _ 만 사용 가능합니다.
                  </div>
                  <div class="error" v-if="empNorequired">필수 입력란입니다.</div>
                  <div class="error" v-if="empNoidRegex">
                    조건에 맞지 않습니다. ※5~20자의 영문 소문자, 숫자와 특수문자 -, _ 만 사용 가능합니다.
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">비밀번호<span class="redDot">*</span></th>
                <td>
                  <input
                    v-model="password"
                    type="password"
                    title="비밀번호 입력"
                    placeholder="영문,숫자,특수문자 조합 8-20자리"
                  />
                  <div class="error" v-if="passwordrequired">필수 입력란입니다.</div>
                  <div class="error" v-if="passwordminLength">8~20자리 입력란입니다.</div>
                  <div class="error" v-if="passwordmaxLength">8~20자리 입력란입니다.</div>
                  <div class="error" v-if="passwordpassRegex">
                    조건에 맞지 않습니다.<br />※ 숫자,영문자,특수문자(!,@,#,$,%,&,*,? 만 사용 가능합니다.)
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">비밀번호 확인<span class="redDot">*</span></th>
                <td>
                  <input type="password" title="비밀번호 재입력" v-model="passwordCon" />
                  <div class="error" v-if="passwordConrequired">필수 입력란입니다.</div>
                  <div class="error" v-if="passwordConsameAsPassword">일치하지 않는 비밀번호입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">이름<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="이름" v-model="empNm" />
                  <div class="error" v-if="empNmrequired">필수 입력란입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">휴대폰번호<span class="redDot">*</span></th>
                <td>
                  <div class="flex">
                    <input type="text" title="휴대폰번호" v-model="empMobile" />
                    <button type="button" class="btn gray" @click="sendAuthNum">중복확인</button>
                  </div>
                  <div class="error" v-if="empMobilerequired">필수 입력란입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">차량번호<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="차량번호 입력" v-model="empCarNo" />
                  <div class="error" v-if="empCarNorequired">필수 입력란입니다.</div>
                  <div class="error" v-if="empCarNocarNoCheck">형식에 맞지 않는 차량번호입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">차량소유주명<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="차량소유주명 입력" v-model="carOwnerNm" />
                  <div class="error" v-if="carOwnerNmrequired">필수 입력란입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">차종</th>
                <td>
                  <input type="text" title="차종 입력" />
                </td>
              </tr>
              <tr>
                <th scope="row">할인<span class="redDot">*</span></th>
                <td>
                  <div class="flex wrap">
                    <input
                      v-for="(dc, index) in discountList"
                      :key="index"
                      type="text"
                      :value="dc.note"
                      title="할인 입력"
                    />
                    <button type="button" @click="chkIrs" class="btn gray">할인적용확인</button>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">주소</th>
                <td>
                  <div class="address">
                    <div class="flex">
                      <input type="text" title="우편번호 입력" />
                      <button type="button" class="btn gray">우편번호</button>
                    </div>
                    <div class="flex">
                      <input type="text" title="주소 입력" />
                      <input type="text" title="상세주소 입력" />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--//table mobile-->

        <!--btnArea-->
        <div class="btnArea">
          <button type="button" class="btn gray" @click="$router.push('membershipagreement')">취소</button>
          <button type="button" class="btn blue" @click="ApplyBtn">가입신청</button>
        </div>
        <!--//btnArea-->
      </div>
    </section>

    <zip-code v-if="showModal">
      <template #info> 우편번호 </template>
      <template #content>
        <article>
          <VueDaumPostcode @complete="searchedAddress" />
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </zip-code>
  </main>
</template>

<script>
import zipCode from '../../../components/PopupType1.vue';
import { VueDaumPostcode } from 'vue-daum-postcode';
import axios from '../../../util/axios';
import { required, sameAs, helpers, or, minLength, maxLength } from 'vuelidate/lib/validators';

const carNoRegex = helpers.regex('carNoRegex', /^\s*([가-히]{2}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/);
const carNoRegexDipl = helpers.regex(
  'carNoRegexDipl',
  /^\s*([외교,영사,준외,협정,국기,준영,대표]{2}){0,1}\s*[0-9]{3}[\s]*[-]{1}[\s]*[0-9]{3}\s*$/,
); //외교차량 정규식
const passRegex = helpers.regex('passRegex', /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/);
const idRegex = helpers.regex('idRegex', /^[A-Za-z]{1}[A-Za-z0-9_-]{5,20}$/);

export default {
  data() {
    return {
      showModal: false,
      zipcode: '',
      addr: '',

      usedCnt: -1,
      empNo: '',
      password: '',
      passwordCon: '',
      empNm: '',
      carOwnerNm: '',
      empCarNo: '',
      addrDetail: '',
      empMobile: '',
      discountCd: [],
      discountList: [{ note: '', dcCode: '' }],

      empNorequired: false,
      empNoidRegex: false,
      passwordrequired: false,
      passwordminLength: false,
      passwordmaxLength: false,
      passwordpassRegex: false,
      passwordConrequired: false,
      passwordConsameAsPassword: false,
      empCarNorequired: false,
      empCarNocarNoCheck: false,
      empCarOwnerrequired: false,
      carOwnerNmrequired: false,
      discountCdrequired: false,
      empNmrequired: false,
      empMobilerequired: false,

      mobileCheck: -1,
    };
  },

  validations: {
    empNo: {
      required,
      idRegex: idRegex,
    },
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20),
      passRegex: passRegex,
    },
    passwordCon: {
      required,
      sameAsPassword: sameAs('password'),
    },
    empNm: {
      required,
    },
    empMobile: {
      required,
    },
    carOwnerNm: {
      required,
    },
    empCarNo: {
      required,
      carNoCheck: or(carNoRegex, carNoRegexDipl),
    },
  },

  components: {
    zipCode,
    VueDaumPostcode,
  },

  mounted() {
    // if (this.$route.params.name == null || this.$route.params.mobile == null) {
    //   alert('본인인증을 다시 시도해주세요.');
    //   this.$router.push('/membershipagreement');
    //   return;
    // }
    this.empNm = this.$route.params.name;
    this.empMobile = this.$route.params.mobile;
  },

  methods: {
    async chkIrs() {
      const apiParams = new FormData();
      apiParams.append('carNo', this.empCarNo);
      apiParams.append('carOwnerNm', this.name);

      const res = await axios('post', '/api/reduction/irs.json', apiParams);

      this.discountList = res.data?.value?.dcList;
      if (this.discountList.length == 0) {
        this.discountList.push({ note: '일반', dcCode: 'DC001' });
        return;
      }
      for (const i of this.discountList) {
        this.discountCd.push(i.dcCode);
      }
    },

    CancleBtn() {
      this.showModal = false;
    },

    daumPostcodeBtn() {
      this.showModal = true;
    },

    searchedAddress(data) {
      this.zipcode = data.zonecode;
      if (data.userSelectedType == 'R') {
        this.addr = data.address;
      } else {
        this.addr = data.jibunAddress;
      }
      this.showModal = false;
    },

    resetUsedCnt() {
      this.usedCnt = -1;
    },

    async idCheck() {
      if (this.$v.empNo.$invalid) {
        this.usedCnt = -2;
        return;
      }
      const res = await axios('get', '/api/member/idDplctCnfirmAjax.json', {
        checkId: this.empNo,
      });
      this.usedCnt = res.data.usedCnt;
    },

    idValidation() {
      if (this.usedCnt === -1) {
        alert('아이디 중복검사를 해주십시오.');
        return false;
      }
      if (this.usedCnt === 1) {
        alert('중복된 아이디입니다.');
        return false;
      }
      if (this.usedCnt === -2) {
        alert('조건에 부합하지 않는 아이디입니다.');
        return false;
      }
      return true;
    },

    async ApplyBtn() {
      if (this.$v.$invalid) {
        for (let i = 0; i < Object.keys(this.$v).length; i++) {
          if (Object.values(this.$v)[i] != (null || undefined)) {
            for (let j = 0; j < Object.keys(Object.keys(this.$v)[i]).length; j++) {
              if (Object.keys(Object.values(this.$v)[i])[j] != (null || undefined)) {
                if (!Object.keys(Object.values(this.$v)[i])[j].includes('$')) {
                  if (!Object.values(Object.values(this.$v)[i])[j]) {
                    this.$data[Object.keys(this.$v)[i] + Object.keys(Object.values(this.$v)[i])[j]] = true;
                  } else {
                    this.$data[Object.keys(this.$v)[i] + Object.keys(Object.values(this.$v)[i])[j]] = false;
                  }
                }
              }
            }
          }
        }
        return;
      }
      if (!this.idValidation()) return;
      if (!this.mobileNumValidation()) return;

      const apiParams = new FormData();
      apiParams.append('empNo', this.empNo);
      apiParams.append('password', this.password);
      apiParams.append('empNm', this.empNm);
      apiParams.append('carOwnerNm', this.carOwnerNm);
      apiParams.append('empCarNo', this.empCarNo.replace(/\s/gi, ''));
      apiParams.append('empMobile', this.empMobile);
      apiParams.append('zipcode', this.zipcode);
      apiParams.append('addr', this.addr);
      apiParams.append('addrDetail', this.addrDetail);

      await axios('post', '/api/member/mberSbscrb.json', apiParams);
      await this.login();
    },

    async login() {
      const res = await axios('post', '/api/actionLogin.json', null, {
        params: {
          empNo: this.empNo,
          password: this.password,
        },
      });
      const data = res.data;
      if (!data.result) {
        alert(data.msg);
        this.password = '';
        this.passwordCon = '';
        return;
      }
      const sessionId = data.attributeMap.SPRING_SECURITY_CONTEXT.authentication.details.sessionId;
      const authorCode = data.attributeMap.loginVO.authorCode;
      const empNo = data.attributeMap.loginVO.empNo;
      const empNm = data.attributeMap.loginVO.empNm;
      const empMobile = data.attributeMap.loginVO.empMobile;
      const empCarNo = data.attributeMap.loginVO.empCarNo;
      const zipcode = data.attributeMap.loginVO.zipcode;
      const addr = data.attributeMap.loginVO.address;
      const addrDetail = data.attributeMap.loginVO.addressDetail;
      const empDiv = data.attributeMap.loginVO.empDiv;

      if (sessionId !== undefined && sessionId !== '') {
        this.$store.dispatch('authorCode', authorCode);
        this.$store.dispatch('empNo', empNo);
        this.$store.dispatch('empNm', empNm);
        this.$store.dispatch('empMobile', empMobile);
        this.$store.dispatch('empCarNo', empCarNo);
        this.$store.dispatch('zipcode', zipcode);
        this.$store.dispatch('addr', addr);
        this.$store.dispatch('addrDetail', addrDetail);
        this.$store.dispatch('empDiv', empDiv);
        this.$store.dispatch('isLogin', true);
        this.$router.push('/main');
      }

      this.$router.push('/membershipcompletion');
    },

    mobileNumValidation() {
      if (this.mobileCheck === -1) {
        alert('핸드폰번호 중복검사를 해주십시오.');
        return false;
      }
      if (this.mobileCheck === 1) {
        alert('이미 가입된 핸드폰 번호입니다.');
        return false;
      }
      return true;
    },

    async sendAuthNum() {
      if (!this.empMobile || !this.empNm) {
        alert('이름, 핸드폰번호를 다시 확인해주세요.');
        return;
      }
      const res = await axios('get', '/api/member/mobileCk.json', {
        empMobile: this.empMobile,
      });
      const data = res.data.result;
      if (data !== true) {
        this.mobileCheck = 1;
        alert('이미 가입된 핸드폰 번호입니다.');
        return;
      }
      this.mobileCheck = 2;
      alert('사용 가능한 핸드폰 번호입니다.');
    },
  },
};
</script>
